export default {
   "messages": {
       "editor": {
           "tabs": {
               "posts": "Posts",
               "groups": "Organisations"
           },
           "post": {
               "publish": "Publish",
               "update": "Update",
               "upload-picture": "Change picture",
               "title": "Title",
               "content": "Content",
               "location": "Location or address",
               "new-event": "New event",
               "edit-post": "Edit post",
               "edit-event": "Edit event",
               "post-as": "Published by",
               "cant-add-more": "You cannot add more than",
               "images": "Pictures",
               "youtube-video": "Youtube video",
               "youtube-video-placeholder": "https://www.youtube.com/...",
               "occurrences": "Select date...",
               "occurrences-placeholder": "Date",
               "post-list": {
                   "create-new-post": "Create new post",
                   "search-post": "Search post...",
                   "last-modification": "Last modification on ",
                   "no-result-for": "No results found for",
                   "refine-search": "For additional articles, please refine search"
               },
               "draft": {
                   "add-link": "Add link",
                   "edit-link": "Edit link",
                   "insert-link": "Insert link",
                   "link-address": "Link address"
               },
               "picture-upload": {
                   "uploading-pictures": "Upload pictures ({processed}/{total})",
                   "saving": "Save"
               },
               "not-valid-youtube-link": "Invalid Youtube link",
               "not-valid-link": "Invalid URL",
               "delete-post": "Delete post",
               "delete-post-button": "Delete",
               "alert-delete-post": "By confirming, this post will be deleted permanently: {postTitle}.",
               "file-size-exceeded": "Maximum file size exceeded (10MB)",
               "errors": {
                   "body-pic-video": "The post, picture or video must be described in more detail",
                   "bad-group": "You cannot publish posts on behalf of the organisation, because you're not a member of the organisation",
                   "bad-json": "Mywort is a local participation platform in and for Luxembourg. Contributions are to be made primarily in German, French, English and Portuguese. Other languages or special characters should therefore please be avoided."
               },
               "messages": {
                   "it-might-take-time": "The update might take a couple of minutes ",
                   "save-success-title": "Your post has been created successfully.",
                   "edit-success-title": "Your post has been updated successfully.",
                   "delete-success-title": "Your post has been deleted."
               },
               "social-sharing": {
                   "message": "Share your post on social media"
               },
               "linked-mission": "Mission",
               "language": "Language"
           },
           "group": {
               "my-groups": "My organisations",
               "joined-groups": "Membership",
               "manage": "Manage",
               "manage-group": "Manage organisation",
               "leave-group": "Leave organisation",
               "new-group": "Create a page for an organisation",
               "edit-group": "Edit organisation",
               "wait-staff-validation": "Your request will be processed. You will soon receive an e-mail.",
               "wait-user-validation": "Please wait until the manager validates your request.",
               "declined-by-user": "Your request has been declined by the organisation manager.",
               "join-requests": "Requests",
               "maintainers": "Members",
               "no-users-request": "No members so far",
               "no-join-request": "No join requests so far",
               "show-declined-requests": "Show declined requests",
               "delete-group": "Delete organisation",
               "alert-leave-group": "You are leaving the '{groupName}' organisation.",
               "alert-delete-group": "By confirming, the organisation '{groupName}' will be deleted permanently. By this action, the organisation will be deleted and all the posts will be shown with the name of the author.",
               "please-enter-reason": "Please enter a reason...",
               "owner": "Manager",
               "picture-upload": {
                   "crop-picture": "Edit picture",
                   "preview-picture": "Preview",
                   "upload-picture": "Change picture",
                   "errors": {
                       "default-error": "The image is corrupt or in an unsupported format",
                       "bad-size": "The picture size is unsupported ({maxSize}mb maximum, {minWidth}px width minimum)"
                   }
               }
           }
       },
       "search": {
           "placeholder": "Text, locality, organisation",
           "for": "Search for '{input}' in mywort",
           "starttyping": "Start typing...",
           "noresults": "No results found",
           "title": "Search...",
           "loading": "Searching...",
           "results-all": "Search results",
           "results-for": "Search results for \"{item}\"",
           "results-around": "in {locality}",
           "results-by": "published by {group}",
           "discover-more": "Discover more",
           "filters": {
               "title": "Filter",
               "reset": "Reset filter",
               "date": {
                   "placeholder": "Date"
               },
               "locality": "Location",
               "municipality": "Municipality",
               "around": "Region"
           },
           "suggestions": {
               "locality": "Location found for",
               "localities": "Locations found for",
               "group": "Organisation found for",
               "groups": "Organisations found for"
           }
       },
       "public": {
           "click-localize": "Click here to localise",
           "remove-localization": "Remove localisation",
           "localization-error": "You declined to share your location. You can change this at any time by enabling localisation in your browser.",
           "my-position": "My position",
           "type-city": "Start typing to select a location",
           "more": "More",
           "published-at": "published on",
           "search": "Search",
           "advanced-search": "Advanced search",
           "please-enter-something": "Please enter something",
           "unlink-post": {
               "unlink": "Remove link",
               "sure-to-unlink": "This action cannot be undone. Are you sure you want to remove the link to this post?"
           },
           "legacy-group-request": {
               "want-create-group": "I want to create this organisation",
               "already-did-request": "You have created the organisation.",
               "wait-for-validation": "Your request has been sent to the mywort.lu administrator for validation.",
               "legacy-organisation": "Become manager of an organisation that has been imported from the old website",
               "group-request-message": "You're authorised to request the management of this organisation that has been imported from the old website. Be the first, click here and..."
           },
           "group-ownership-request": {
               "become-owner": "Become organisation manager",
               "group-ownership-message": "Publish articles on behalf of the organisation",
               "want-to-own": "Take over organisation",
               "email-subject": "Request for taking over an organisation",
               "email-body": "Hello, I want to be the manager of the '{groupName}' organisation. Kind regards, {ownerName}"
           },
           "group-request": {
               "modal": {
                   "group-name": "Organisation name",
                   "description": "Description"
               }
           },
           "join-group-request": {
               "modal": {
                   "title": "Send a join request",
                   "comments-to-owner": "Dear organisation manager, \n" +
                       "I would like to contribute to your organisation and write articles on behalf of your organisation. \n" +
                       "Would it be okay for you? \n" +
                       "Thanks!"
               },
               "want-join-group": "Join organisation",
               "wait-for-validation": "A join request has been sent to the organisation manager for validation",
               "please-enter-comment": "Please enter comment...",
               "become-maintainer": "Become a member",
               "join-group-message": "As a member, you are authorised to create posts on behalf of the organisation. Click on the button to send a join request to the organisation manager. "
           }
       },
       "user-module": {
           "signup-login": "Log in",
           "manage-posts": "Manage posts<br>",
           "latest-posts": "Latest posts",
           "manage-groups": "Manage organisations<br>",
           "logout": "Log out",
           "add-post": "Add post",
           "my-articles": "Posts",
           "my-groups": "Organisations",
           "login-mywort": "Log in",
           "logout-mywort": "Log out",
           "settings-mywort": "Edit profile",
           "profile": "Profile",
           "empty-post": "No post for now",
           "register-mywort": "Register to mywort",
           "carousel-title-1": "Free and made for you",
           "carousel-sub-1": "Do you have an announcement or news you’d like to share with Luxembourg’s English-speaking community?",
           "carousel-title-2": "User-generated content",
           "carousel-sub-2": "Upload your news, announcements,",
           "carousel-sub-2-1": "photos and videos using mywort",
           "carousel-title-3": "Clubs, groups, associations",
           "carousel-sub-3": "Create your own homepage for your organisation.",
           "carousel-title-5": "Start now",
           "already-member?": "Already a member?",
           "connect": "Log in here",
           "hi": "Moien",
           "expect": "Welcome!",
           "take-a-look": "Take a look at our new website and publish your first posts and events right away",
           "create-first": "Create post",
           "create-text-footer": "It will only take a few minutes - try it!",
           "you-are-blocked": "Your mywort account has been blocked by the mywort.lu administrator",
           "contact-admin": "Please contact us for more information",
           "contact-email": "contact@mywort.lu",
           "faq": "FAQ"
       },
       "geolocation": {
           "placeholder": "Enter location",
           "choose-city": "Verify your location",
           "fallback-city": "No matching city found : fallback to Luxemburg city"
       },
       "user-auth": {
           "loading": "Load",
           "not-logged-in": "You are not logged in"
       },
       "picture-upload": {
           "drag-or-click-to-upload": "Drag pictures here or click here to upload pictures",
           "remaining-pictures": "{pictures} pictures remaining",
           "remove": "Remove",
           "retry": "Retry",
           "upload-failed-error": "An unforeseen error occurred. Please try again or remove the concerned pictures",
           "corrupted-pictures-error": "Some of the pictures are corrupted, please remove these pictures",
           "bad-quality-pictures-warning": "Some of the pictures don't have an ideal size. For the print newspaper, the images requires a minimum width of 2500 px.",
           "not-accepted": "These pictures have been declined by the server",
           "bad-color-profile": "Unsupported color profile",
           "over-pixels": "The picture resolution should be under 35 Mpx",
           "over-bytes": "The picture size should be under 20 MB",
           "try-again": "Please try again.",
           "not-uploaded-yet": "Not yet uploaded",
           "will-be-main-picture": "This picture will be the main picture of your post",
           "set-main-picture": "Set as main picture",
           "main-picture": "Main picture",
           "better-quality": "Please note: The image size is not ideal. For the print newspaper, the image requires a minimum width of 2500 px."
       },
       "alert-box": {
           "default-message": "An error has occurred",
           "reload-message": "Click here to refresh the page"
       },
       "spinner": {
           "timeout-title": "An error has occurred...",
           "timeout-message": "Please check your connection or refresh the page",
           "refresh-button-title": "Update"
       },
       "react-validation": {
           "error-message-field-name": "This field",
           "count-message": "{count} remaining characters",
           "messages": {
               "required": "%s required",
               "whitespace": "%s required",
               "string": {
                   "min": "%s a minimum of %s characters is necessary",
                   "max": "%s may not exceed %s characters"
               },
               "number": {
                   "min": "%s may not be less than %s",
                   "max": "%s may not exceed %s"
               }
           }
       },
       "react-select": {
           "no-result-found": "No results found"
       },
       "commons": {
           "submit": "Send",
           "confirm": "Confirm",
           "close": "Close",
           "cancel": "Cancel",
           "go-back": "Go back",
           "finish": "Ok",
           "view": "View",
           "edit": "Edit",
           "change": "Change",
           "accept": "Accept",
           "decline": "Decline",
           "delete": "Delete",
           "upload": "Upload",
           "locality": "Location",
           "users": "User",
           "group": "Organisation",
           "type": "Posts",
           "post": "News",
           "posts": "News",
           "event": "Event",
           "events": "Events",
           "new-contribution": "New post",
           "comment-for-admin": "Why do you want to create this page?",
           "picture": "Picture",
           "pictures": "Pictures",
           "create-group-request": "Create page for organisation",
           "date": "Date",
           "view-content-in-wort": "View",
           "view-group-in-wort": "Page",
           "about": "Description",
           "filter": "Filter",
           "clear": "Delete",
           "language": "Language"
       },
       "landing": {
           "tabs": {
               "posts": "News",
               "events": "Events",
               "localitys": "Localities",
               "groups": "Organisations"
           },
           "info-box": {
               "locality-message": "Some articles have been published recently in these localities:",
               "group-message": "Some articles have been published recently by these organisations:"
           }
       }
   }
};



// WEBPACK FOOTER //
// ./js/mywort/commons/i18n/TranslationEnglish.js